<template>
  <div class="media-btn">
    <div class="media-btn-item" @click="menuClickHandler(1)">
      <img
        src="@/assets/clock/clockin_icon_voice.png"
        alt=""
        class="media-icon"
      />
      语音
    </div>
    <div class="media-btn-item" @click="menuClickHandler(2)">
      <img
        src="@/assets/clock/clockin_icon_picture.png"
        alt=""
        class="media-icon"
      />
      图片
    </div>
    <div class="media-btn-item" @click="menuClickHandler(3)">
      <img
        src="@/assets/clock/clockin_icon_video.png"
        alt=""
        class="media-icon"
      />
      视频
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    menuClickHandler(idx) {
      this.$emit('menuclick', idx);
    }
  }
};
</script>

<style lang="stylus" scoped>
.media-btn {
  display flex
  align-items center
  justify-content space-between
  padding: 16px;

  .media-btn-item {
    display flex
    align-items center
    justify-content center
    width: 70px;
    font-size: 12px;
    color: #666666;

    .media-icon {
      width: 37px;
      height: 36px;
      border: none;
    }
  }
}
</style>
